import {
  DoubleDateMode,
  DoubleDateWithMode,
} from '../double-date-picker/double-date-picker.interfaces';

export const queryParamKey = (
  mode: DoubleDateMode,
  direction: 'from' | 'to'
): string => {
  let result = '';
  switch (mode) {
    case DoubleDateMode.CREATION_DATE:
      result = 'date';
      break;
    case DoubleDateMode.DELIVERY_DATE:
      result = 'delivery_date';
      break;
    case DoubleDateMode.PAYMENT_DATE:
      result = 'payment_date';
      break;
    default:
      throw new Error('Unsupported date filter mode');
  }

  return `${result}_${direction}`;
};

// generateDateFilterQueryParam returns query param for date filter
// The query param starts by &
export const generateDateFilterQueryParam = (
  d?: DoubleDateWithMode
): string => {
  if (!d) return '';
  const from_key = queryParamKey(d.mode, 'from');
  const to_key = queryParamKey(d.mode, 'to');

  const parts: string[] = [];
  if (d.startDate !== null)
    parts.push(
      `${from_key}=${encodeURIComponent(d.startDate.format('YYYY-MM-DD'))}`
    );

  if (d.endDate !== null)
    parts.push(
      `${to_key}=${encodeURIComponent(d.endDate.format('YYYY-MM-DD'))}`
    );

  return parts.join('&');
};
